import { TreeNode } from "@/types/tree";
import {
  setImageControlsInSectionToStockPhotoSearchResults,
  setStockPhotoSearchKeywordsForImageControlsInASection,
  setStockPhotoSearchResultsForImageControlsInASection
} from "./images";
import { initPopulateImageDimensions } from "./design-library-dimensions-population/dimensions-population";

export async function replaceImagesInSectionWithAi(
  section: TreeNode,
  abortController: AbortController
) {
  console.log("replaceImagesInSectionWithAi starting...", section.id);

  await setStockPhotoSearchKeywordsForImageControlsInASection(section, "store", abortController);
  await setStockPhotoSearchResultsForImageControlsInASection(section, "store", abortController);
  await setImageControlsInSectionToStockPhotoSearchResults(section, "store", abortController);

  console.log("replaceImagesInSectionWithAi done for", section.id);
}

export async function replaceImagesInSectionWithAiMutating(
  section: TreeNode,
  abortController: AbortController
): Promise<TreeNode> {
  console.log("replaceImagesInSectionWithAiMutating starting...", section.id);

  await setStockPhotoSearchKeywordsForImageControlsInASection(
    section,
    "mutate",
    abortController
  );
  await setStockPhotoSearchResultsForImageControlsInASection(section, "mutate", abortController);
  await setImageControlsInSectionToStockPhotoSearchResults(section, "mutate", abortController);

  console.log("replaceImagesInSectionWithAiMutating done for", section.id);

  return section;
}

initPopulateImageDimensions();